import { render, staticRenderFns } from "./MdtWizardMenu.vue?vue&type=template&id=a160ca7a&scoped=true"
import script from "./MdtWizardMenu.vue?vue&type=script&lang=js"
export * from "./MdtWizardMenu.vue?vue&type=script&lang=js"
import style0 from "./MdtWizardMenu.vue?vue&type=style&index=0&id=a160ca7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a160ca7a",
  null
  
)

export default component.exports